import { addListener, createListenerMiddleware } from '@reduxjs/toolkit';
import type { TypedAddListener, TypedStartListening } from '@reduxjs/toolkit';
import { setContext } from '@alltrails/context/slices/contextSlice';
import { api } from '@alltrails/core/utils/api';
import { setListsAndListItems } from '@alltrails/lists/slices/lists';
import getListsAndListItems from '@alltrails/lists/utils/requests';
import { setGreetings } from '../slices/greetings';
import { setSections } from '../slices/sections';
import type { HomepageResponse } from '../utils/types';
import type { AppDispatch, RootState } from './redux';

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<RootState, AppDispatch>;

const onUserLogin = async (action, listenerApi) => {
  if (action.payload.currentUser) {
    const [userLists, homepageData] = await Promise.all([getListsAndListItems(), api<HomepageResponse>('/api/alltrails/v1/web/homepage')]);

    listenerApi.dispatch(setListsAndListItems(userLists));

    if (homepageData.greetings) {
      listenerApi.dispatch(setGreetings(homepageData.greetings));
    }
    if (homepageData.sections) {
      listenerApi.dispatch(setSections(homepageData.sections));
    }
  }
};

export const setupListeners = () => {
  startAppListening({ actionCreator: setContext, effect: onUserLogin });
};
